import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import WhatsAppButton from "@/components/WhatsAppButton";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";

import Home from "@/pages/Home";
import Method from "@/pages/Method";
import Cases from "@/pages/Cases";
import AboutMe from "@/pages/AboutMe";
import Contact from "@/pages/Contact";
import Booking from "@/pages/Booking";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Documents from "@/pages/Documents";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("config", "AW-18441432775", { page_path: pathname });
    }
  }, [pathname]);
  return null;
}

function AppShell() {
  const [showChat, setShowChat] = React.useState(false);
  useEffect(() => {
    const rIC = window.requestIdleCallback || ((cb) => setTimeout(cb, 1500));
    const id = rIC(() => setShowChat(true), { timeout: 3000 });
    return () => (window.cancelIdleCallback ? window.cancelIdleCallback(id) : clearTimeout(id));
  }, []);
  return (
    <div className="min-h-screen bg-[#FFFFFF] grain">
      <Header />
      <main>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/metodo" element={<Method />} />
          <Route path="/casi" element={<Cases />} />
          <Route path="/chi-siamo" element={<AboutMe />} />
          <Route path="/chi-sono" element={<AboutMe />} />{/* redirect-friendly legacy path */}
          <Route path="/contatti" element={<Contact />} />
          <Route path="/prenota" element={<Booking />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/documenti" element={<ProtectedRoute><Documents /></ProtectedRoute>} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppButton />
      {showChat && <ChatWidget />}
      <Toaster
        position="bottom-left"
        toastOptions={{
          style: { background: "#0B1F3F", color: "#FFFFFF", border: "1px solid #14417B", fontFamily: "'Inter', sans-serif" },
        }}
      />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <SmoothScroll>
          <AppShell />
        </SmoothScroll>
      </BrowserRouter>
    </AuthProvider>
  );
}
